import {
  Chip,
  chipVariants as packageChipVariants,
  type ChipProps as PackageChipProps,
} from '@ayble-health/dashboard-components';

/**
 * careOS Chip — the package component with one vocabulary narrowing.
 *
 * The careOS variants (aqua, canvas, symptom, alert, mint, ballet) and label
 * typography forwarding landed upstream in v1.3.0. The only local concern left
 * is vocabulary: the package ships `outline`, which careOS omits in favour of
 * `symptom` — see the Archive tab.
 */

export { Chip };

/** Narrows Chakra's ConditionalValue wrapper to plain strings. */
type VariantOf<T> = T extends string ? T : never;

export type ChipVariant = Exclude<
  VariantOf<NonNullable<PackageChipProps['variant']>>,
  'outline'
>;

export type ChipProps = Omit<PackageChipProps, 'variant'> & {
  variant?: ChipVariant;
};

/** Package variants minus `outline`, in careOS display order. */
export const chipVariants: ChipVariant[] = (
  packageChipVariants as VariantOf<NonNullable<PackageChipProps['variant']>>[]
).filter((v): v is ChipVariant => v !== 'outline');
